import { useCallback } from 'react';
import { GasType, CalculationMode } from '../types/gasTypes';

export interface ConfigData {
  gasTypes: GasType[];
  targetAlcoholPercent: number | string;
  targetOctane: number | string;
  budget: number | string;
  calculationMode: CalculationMode;
}

const STORAGE_KEY = 'octanify-config';

export const useConfigStorage = () => {
  const saveConfig = useCallback((config: ConfigData) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
    } catch (error) {
      console.error('Failed to save config to localStorage:', error);
    }
  }, []);

  const loadConfig = useCallback((): ConfigData | null => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        // Validate the loaded config has the expected structure
        if (parsed && parsed.gasTypes && Array.isArray(parsed.gasTypes)) {
          return parsed;
        }
      }
    } catch (error) {
      console.error('Failed to load config from localStorage:', error);
    }
    return null;
  }, []);

  const getDefaultConfig = (): ConfigData => ({
    gasTypes: [
      { id: 1, name: 'E10', alcoholPercent: 10, octaneRating: 95, pricePerLiter: 1.45 },
      { id: 2, name: 'E85', alcoholPercent: 85, octaneRating: 104, pricePerLiter: 1.25 }
    ],
    targetAlcoholPercent: 25,
    targetOctane: 98,
    budget: 50,
    calculationMode: 'alcohol' as CalculationMode
  });

  return {
    saveConfig,
    loadConfig,
    getDefaultConfig
  };
};